import axios from "./axios/rawAxios"

export const postData = async ( value ) => {
    const data = await axios.post(`/api/trips` , value);
    return data;
}
export const getData = async () => {
    const data = await axios.get(`/api/trips/user_trips` );
    return data;
}
export const postPayment = async (id) => {
    const data = await axios.post(`/api/sender/payment?parcel_id=${id}` );
    return data;
}
export const getInfo = async () => {
    const data = await axios.get(`/api/user-info` );
    return data;
}